const POST_PRESIGNED_URL = "v1/yamcs-packages/file/presigned-url";
const GET_ME = `v1/user/me`;
const GET_USER_LIST = `v1/users`;
const POST_PRE_SIGNED_UPLOAD = `v1/pre-signed-upload`;
const GET_TOKEN = `v1/oauth/token`;
const GET_PROJECTS = `v1/projects`;
const GET_PROJECT_ROLE = (id) => `v1/projects/${id}/role`;
const POST_CLONE_S3_FILE = "v1/clone-s3-file";

const GET_PROJECT_DETAIL = (id) => `v1/projects/${id}`;

// project instances
const GET_INSTANCES = `v1/yamcs-packages`;
const CREATE_INSTANCE = `v1/yamcs-packages`;
const DEPLOY_INSTANCE = `v1/greengrass/deployments`;
const GET_INSTANCE_DETAIL = (id) => `v1/yamcs-packages/${id}`;
const GET_INSTANCE_UPLOAD_FILE_HISTORIES = (id) => `v1/yamcs-packages/${id}/file-histories`;
const EDIT_INSTANCE = (id) => `v1/yamcs-packages/${id}`;

// test packages
const GET_TEST_PACKAGES = `v1/test-packages`;
const CREATE_TEST_PACKAGE = `v1/test-packages`;
const GET_TEST_PACKAGE_DETAIL = (id) => `v1/test-packages/${id}`;
const GET_TEST_PACKAGE_FILES_HISTORIES = `v1/hash-registry-histories`;
const EDIT_TEST_PACKAGE = (id) => `v1/test-packages/${id}`;
const GET_TEST_SEQUENCE_TAGS = (id) => `v1/test-sequence-tags?test_package_id=${id}`;
const UPDATE_TEST_SEQUENCE_TAGS = (id) => `v1//test-sequence-tags?test_package_id=${id}`;

//sequences
const GET_SEQUENCES = `v1/sequence-packages`;
const GET_SEQUENCE_DETAIL = (id) => `v1/sequence-packages/${id}`;
const GET_TEST_PACKAGE_OPTIONS = (type) => `v1/test-packages?instance-id=${type}`;
const EDIT_SEQUENCE_DETAIL = (id) => `v1/sequence-packages/${id}`;
const GET_FILES_DOWNLOAD_SEQUENCE_PACKAGE = "v1/sequence-packages/files/download-urls";
const GET_SEQUENCE_TAGS = (id) => `v1/sequences/${id}/tags`;
const ADD_SEQUENCE_TAGS = "v1/sequence-tags";

const GET_SERVER_STATUS = "v1/instance-status/matlab-batch/sync";
const POST_REBOOT_SERVER = "v1/instance-status/matlab-batch/reboot";

export {
  POST_PRESIGNED_URL,
  GET_ME,
  GET_USER_LIST,
  POST_PRE_SIGNED_UPLOAD,
  GET_TOKEN,
  GET_PROJECTS,
  GET_PROJECT_DETAIL,
  GET_PROJECT_ROLE,
  GET_SERVER_STATUS,
  POST_REBOOT_SERVER,
  POST_CLONE_S3_FILE,
  CREATE_INSTANCE,
  DEPLOY_INSTANCE,
  GET_INSTANCES,
  GET_INSTANCE_DETAIL,
  GET_INSTANCE_UPLOAD_FILE_HISTORIES,
  EDIT_INSTANCE,
  GET_TEST_PACKAGES,
  CREATE_TEST_PACKAGE,
  GET_TEST_PACKAGE_DETAIL,
  GET_TEST_PACKAGE_FILES_HISTORIES,
  EDIT_TEST_PACKAGE,
  GET_TEST_SEQUENCE_TAGS,
  UPDATE_TEST_SEQUENCE_TAGS,
  GET_SEQUENCES,
  GET_TEST_PACKAGE_OPTIONS,
  GET_SEQUENCE_DETAIL,
  EDIT_SEQUENCE_DETAIL,
  GET_FILES_DOWNLOAD_SEQUENCE_PACKAGE,
  GET_SEQUENCE_TAGS,
  ADD_SEQUENCE_TAGS,
};
